import InfoIndicator from "@app/shared/InfoIndicator";
import { JSX } from "react";

export default function InformationalSpecialtyGroupIndicator(props: { visible: boolean; isInformational: boolean }): JSX.Element {
  if (!props.visible) {
    return null;
  }
  const indicator = props.isInformational
    ? <InfoIndicator className="informational-indicator" tooltipTitle="Informational specialty groups do not impact overall results." tooltipPlacement="right" />
    : <span className="informational-indicator" />;

  return (
    <>{indicator}&nbsp;</>
  );
}
